import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule, Routes } from '@angular/router'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'

import { AgentLoginComponent } from './login/agent-login.component'
import { AgentLoginService } from './login/agent-login.service';
import { SharedModule } from '../shared'
import { UIModule } from 'app/shared/UI.module'
import { AgentLogoutComponent } from './logout/agent-logout.component';

const appRoutes: Routes = [
    { path: 'agent/account/login', component: AgentLoginComponent },
    { path: 'Agent/Account/LogIn', component: AgentLoginComponent },
    { path: 'agent/account/_logout', component: AgentLogoutComponent },
    { path: 'agent/login', component: AgentLoginComponent },
    { path: 'Agent/Login', component: AgentLoginComponent }
]

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        UIModule
    ],
    declarations: [
        AgentLoginComponent,
        AgentLogoutComponent
    ],
    providers: [AgentLoginService]
})

export class AgentModule { }
